'use strict';

const _=require('pulsar-utils/dist-es6/_');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

NotificationSettingsController=class NotificationSettingsController extends BaseController{
static get $inject(){
return['$timeout','uncaughtErrorHandler','userService','breadcrumbsService','groupBasedDataHelperService'];
}

constructor($timeout,uncaughtErrorHandler,userService,breadcrumbsService,groupBasedDataHelperService){
super(uncaughtErrorHandler);

this._$timeout=$timeout;
this._userService=userService;

this.notificationSettingsSubViewConfiguration=this._getNotificationSettingsSubViewConfiguration();

breadcrumbsService.startTrail('Email Notifications');


groupBasedDataHelperService.clearCaches();
}

get emailAddress(){
return _.get(this._userService,'currentUser.email');
}

_getNotificationSettingsSubViewConfiguration(){
return ControllerExtensions(this).getMultiViewConfigurationFor(['emailAddress'],[{
label:'Notification Settings',
directiveName:'pulsar-groups-notification-settings-subview'},
{
label:'Do Not Disturb',
directiveName:'pulsar-do-not-disturb-notification-settings'}]);

}};


module.exports=NotificationSettingsController;
//# sourceMappingURL=notificationSettingsController.js.map
